/**
 * Centralized analytics/tracking utility.
 * Fires events to Facebook Pixel, GA4, and GTM dataLayer.
 */

export function trackPurchase({ value, currency = "USD", eventId, eventName, ticketCount }) {
  if (typeof window.fbq === "function") {
    window.fbq("track", "Purchase", {
      value,
      currency,
      content_name: eventName,
      content_ids: [String(eventId)],
      content_type: "product",
      num_items: ticketCount,
    });
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "purchase", {
      transaction_id: `${eventId}_${Date.now()}`,
      value,
      currency,
      items: [
        {
          item_id: String(eventId),
          item_name: eventName,
          quantity: ticketCount,
          price: value / ticketCount,
        },
      ],
    });
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "purchase",
    ecommerce: {
      transaction_id: `${eventId}_${Date.now()}`,
      value,
      currency,
      items: [
        {
          item_id: String(eventId),
          item_name: eventName,
          quantity: ticketCount,
          price: value / ticketCount,
        },
      ],
    },
  });
}

export function trackAddToCart({ value, currency = "USD", eventId, eventName }) {
  if (typeof window.fbq === "function") {
    window.fbq("track", "AddToCart", {
      value,
      currency,
      content_name: eventName,
      content_ids: [String(eventId)],
      content_type: "product",
    });
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "add_to_cart", {
      currency,
      value,
      items: [{ item_id: String(eventId), item_name: eventName, price: value }],
    });
  }
}

export function trackLead({ eventId, eventName }) {
  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead", {
      content_name: eventName,
      content_category: "ticket_interest",
    });
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "generate_lead", {
      event_label: eventName,
    });
  }
}

export function trackSignUp({ method = "email" }) {
  if (typeof window.fbq === "function") {
    window.fbq("track", "CompleteRegistration", { method });
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "sign_up", { method });
  }
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUTMParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmData = {};
    let hasUTM = false;

    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) {
        utmData[key] = value;
        hasUTM = true;
      }
    });

    if (hasUTM) {
      sessionStorage.setItem("teder_utm", JSON.stringify(utmData));
    }
  } catch (e) {
    // sessionStorage may not be available
  }
}

export function getStoredUTMParams() {
  try {
    const stored = sessionStorage.getItem("teder_utm");
    return stored ? JSON.parse(stored) : {};
  } catch (e) {
    return {};
  }
}
